import * as yup from 'yup';

export const DEDUCTION_ADJUSTMENT_MAX_AMOUNT = 5000;
export const DEDUCTION_ADJUSTMENT_NOTES_MIN_LENGTH = 10;
export const DEDUCTION_ADJUSTMENT_NOTES_MAX_LENGTH = 1000;

const deductionAdjustmentSchema = yup.object({
  direction: yup
    .string()
    .oneOf(['DEDUCT', 'NET_ADDITION'])
    .required('Choose whether to deduct more or add a net addition'),
  amount: yup
    .string()
    .required('Amount is required')
    .test('is-positive', 'Amount must be more than £0', (value) => parseFloat(value || '') > 0)
    .test(
      'is-within-limit',
      'Amount can be at most £5,000',
      (value) => parseFloat(value || '') <= DEDUCTION_ADJUSTMENT_MAX_AMOUNT
    )
    .test('has-pence-at-most', 'Amount can have at most two decimal places', (value) =>
      /^\d+(\.\d{1,2})?$/.test(value || '')
    ),
  notes: yup
    .string()
    .trim()
    .required('A reason is required')
    .min(DEDUCTION_ADJUSTMENT_NOTES_MIN_LENGTH, 'The reason must be at least 10 characters')
    .max(DEDUCTION_ADJUSTMENT_NOTES_MAX_LENGTH, 'The reason cannot exceed 1,000 characters'),
});

export default deductionAdjustmentSchema;
